import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { toHttpParams } from '@/utils/common'
import type { MedicoElegivelCirurgiaConjunta, MedicosElegiveisCirurgiaConjuntaQuery, AssociarCirurgiaConjuntaPayload, SolicitacoesElegiveisCirurgiaConjuntaQuery, SolicitacaoElegivelParaCirurgiaConjunta, CirurgiaConjuntaTriagemResponse } from '@/types/interfaces/CirurgiaConjunta'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {
  async getMedicosElegiveis(query: MedicosElegiveisCirurgiaConjuntaQuery) {
    const request = await api.get(`cirurgia-conjunta/medicos-elegiveis?${toHttpParams(query)}`)

    return {
      ...factory.build<MedicoElegivelCirurgiaConjunta[]>(request),
      total: (request.data && request.data.total) || 0,
    }
  },

  async getSolicitacoesElegiveis(query: SolicitacoesElegiveisCirurgiaConjuntaQuery) {
    const request = await api.get(`solicitacoes-backoffice/cirurgia-conjunta/solicitacoes-elegiveis?${toHttpParams(query)}`)
    return factory.build<SolicitacaoElegivelParaCirurgiaConjunta[]>(request)
  },

  async associar(hospitalId: string, payload: AssociarCirurgiaConjuntaPayload) {
    const request = await api.put(`solicitacoes-backoffice/${hospitalId}/cirurgia-conjunta/associar`, payload)
    return factory.build<void>(request)
  },

  async desassociar(hospitalId: string, cirurgiaConjuntaId: string) {
    const request = await api.put(`solicitacoes-backoffice/${hospitalId}/cirurgia-conjunta/${cirurgiaConjuntaId}/desassociar`, {})
    return factory.build<void>(request)
  },

  async getCirurgiaConjuntaTriagem(solicitacaoId: string) {
    const request = await api.get(`solicitacoes-backoffice/${solicitacaoId}/cirurgia-conjunta-triagem`)
    return factory.build<CirurgiaConjuntaTriagemResponse>(request)
  },
}
